import axios from 'axios';
import { apiUrl } from './index';

export default {
  getLanguages() {
    return axios({
      method: 'get',
      url: `${apiUrl}/configs/languages`,
    });
  },
  getTimezones() {
    return axios({
      method: 'get',
      url: `${apiUrl}/configs/timezones`,
    });
  },
  getCountries(params) {
    return axios({
      method: 'get',
      url: `${apiUrl}/configs/countries`,
      params,
    });
  },
  getColors() {
    return axios({
      method: 'get',
      url: `${apiUrl}/configs/colors`,
    });
  },
};
